<template>
  <v-expansion-panel
    ref="panel"
    @change="onChange"
  >
    <v-expansion-panel-header
      id="post-processing-requests-header"
      ripple
    >
      <v-row>
        <v-col cols="12">
          <span
            :class="['body-1', {
            'post-processing-active--text': postProcessingsIsActive,
            'grey--text text--darken-1': !postProcessingsIsActive
          }]"
          >Solicitação de Análises Agronômicas</span>
        </v-col>
      </v-row>
    </v-expansion-panel-header>
    <v-expansion-panel-content id="post-processing-requests-content">
      <v-skeleton-loader
        v-if="isLoading"
        :loading="isLoading"
        type="article"
        class="mx-auto flex-fill"
        width="100%"
      />
      <v-scale-transition>
        <v-container
          v-if="!isLoading"
          fluid
          class="pa-1"
        >
          <v-row
            id="crop-type-select"
            class="ma-0 pt-4"
          >
            <v-select
              label="Escolha a cultura"
              v-model="abCropType"
              outlined
              clearable
              :items="cropTypesFilterList"
              @change="onAbCropTypeChange"
              hide-details
            />
          </v-row>
          <fragment
            v-if="abCropType"
          >
            <v-row
              v-if="analysisTypesIsEmpty"
              class="ma-0"
            >
              <empty-state
                color="primary"
                class="text-center text--secondary"
              >
                <template v-slot:description>
                  Erro ao carregar tipos de análises
                </template>
              </empty-state>
            </v-row>
            <v-row
              v-else
              class="ma-0 flex-column"
            >
              <v-subheader>
                Escolha os tipos de análise:
              </v-subheader>
              <analysis-types
                v-model="selectedAnalysisTypes"
                :post-processing-prices="postProcessingPrices"
                :ab-crop-type="abCropType"
                :fl-price-multiplier.sync="flPriceMultiplier"
                v-on:changePlanType="onChangePlanType"
              />
            </v-row>
            <v-row
              class="mx-0 my-2"
            >
              <v-divider/>
            </v-row>
            <v-row
              v-if="selectedAnalysisTypes.length === 0"
              justify="center"
              class="ma-0"
            >
              <empty-state
                color="primary"
                class="text-center text--secondary field-list-empty"
              >
                <template v-slot:description>
                  Selecione as análises e áreas para iniciar o processo de solicitação de análises agronômicas
                </template>
              </empty-state>
            </v-row>
            <v-row
              v-else
              class="ma-0"
            >
              <v-subheader>
                Análises selecionadas:
              </v-subheader>
              <post-processing-request-analysis-card
                v-for="item in selectedAnalysisTypes"
                :key="item['ab_analysis_type']"
                :item="item"
                :fl-total-area="flTotalArea"
                :ab-crop-type="abCropType"
                :post-processing-prices="postProcessingPrices"
              >
              </post-processing-request-analysis-card>
            </v-row>
            <v-row
              class="mx-0 my-2"
            >
              <v-divider/>
            </v-row>
            <v-row
              class="ma-0"
              v-if="chargeTypeIsCredits"
            >
              <span class="body-1 font-weight-bold">TOTAL</span>
              <v-spacer/>
              <span class="body-2">{{currencySymbol}} {{flTotalPrice | toFixedWithComma}}</span>
            </v-row>
            <v-row
              class="ma-0"
              v-else
            >
              <v-tooltip
                top
              >
                <template v-slot:activator="{ on }">
                  <v-icon
                    color="warning"
                    small
                    v-on="on"
                    class="price-info__icon ma-2 my-6"
                  >
                    {{$vuetify.icons.values["mdiAlertCircle"]}}
                  </v-icon>
                </template>
                <span >A área mínima para análise é de 20 Hectares</span>
              </v-tooltip>
              <v-col>
                <span class="body-1 font-weight-bold">HECTARES</span>
                <v-row class="mx-0">
                  <span class="body-3">{{hectarePlanType}}</span>
                </v-row>
              </v-col>
              <v-spacer/>
              <span class="body-2 my-6">{{flTotalArea | toFixedWithComma}}</span>
            </v-row>
            <v-row
              class="mx-0 my-2"
            >
              <v-divider/>
            </v-row>
            <v-row
              class="ma-0"
            >
              <v-col
                cols="12"
                md="6"
                lg="6"
                xl="6"
              >
                <v-btn
                  color="error"
                  outlined
                  block
                  @click="onCancelClick"
                  :disabled="isRequesting"
                >
                  Cancelar
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                md="6"
                lg="6"
                xl="6"
              >
                <v-btn
                  color="success"
                  block
                  @click="onConfirmClick"
                  :loading="isLoadingConfirm || isRequesting"
                  :disabled="flTotalPriceIsEmpty"
                >
                  Confirmar
                </v-btn>
              </v-col>
            </v-row>
          </fragment>
        </v-container>
      </v-scale-transition>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
  import {mapActions} from "vuex"
  import store from "../../../../store"
  import {GET_USER_DATA} from "../../../../store/modules/user"
  import {SET_IS_POST_PROCESSING_REQUEST_STATE} from "../../../../store/modules/mapview"
  import {PostProcessingsRequestEventBus} from "../../../../helpers/post-processings/events"
  import {find, forEach, some, map} from "lodash/collection"
  import {FloatingCardsEventBus} from "../../../../helpers/mapview/events"
  import {FEATURE_GROUPS} from "../../../../helpers/leaflet/constants"
  import {LAYER_COLORS} from "../../../../helpers/mapview/constants"
  import {
          addUpdatePostProcessing, listPostProcessingPrices, 
          getUserTotalHectarePackage, getAfterProcessingItens          
  } from "../../../../api/api-billing"
  import {NOTIFICATION_TYPES, NotificationOptions} from "../../../../helpers/notify"
  import {isEmpty, isEqual, lt} from "lodash/lang"
  import {findIndex} from "lodash/array"
  import AnalysisTypes from "./AnalysisTypes"
  import EmptyState from "../../../Helpers/EmptyState"
  import PostProcessingRequestAnalysisCard from "./PostProcessingRequestAnalysisCard"
  import {DIALOG_TYPES, DialogOptions} from "../../../../helpers/dialogs"
  import {createFieldsPostProcessing} from "../../../../api/api-project"
  import {CROP_TYPES_FILTER_LIST} from "../../../../helpers/fields/constants"

  const _Map = Symbol.for("_Map")
  const _Processing = Symbol.for("_Processing")

  export default {
    name: "PostProcessingPanel",
    components: {PostProcessingRequestAnalysisCard, EmptyState, AnalysisTypes},
    inject: {_Map, _Processing},
    data: () => ({
      isLoading: true,
      isRequesting: false,

      fields: [],
      selectedAnalysisTypes: [],
      postProcessingPrices: null,
      hectarePlanType: null,

      abCropType: null,
      isLoadingConfirm: false,

      flPriceMultiplier: 0.0,
      postProcessingsIsActive: false,

      insufficient_funds: false,
    }),
    methods: {
      onChangePlanType(planType){
        const tipo = ["Básico", "Intermediário", "Avançado"]
        this.hectarePlanType = tipo[planType-1]
      },
      onAdd(item) {
        if (find(this.fields, ["field.id_field", item["field"]["id_field"]])) {
          this.onRemove(item)
          return
        }

        if (this.isAllowedToAdd()) {
          item["layer"].setPostProcessingRequestStyle()
          this.fields.push(item)
        }
      },
      onRemove(item) {
        const idx = findIndex(this.fields, ["field.id_field", item["field"]["id_field"]])
        this.fields.splice(idx, 1)
        item["layer"].clearStyle()
      },
      onActive() {
        this.$nextTick()
          .then(() => {
            FloatingCardsEventBus.$emit("close")
            forEach(this.fields, item => item["layer"].setPostProcessingRequestStyle())
          })
      },
      onChange() {
        this.setIsPostProcessingRequestState(!this.$refs["panel"].isActive)
        if (!this.$refs["panel"].isActive) {
          this.postProcessingsIsActive = true
          this.onActive()
        } else {
          this.postProcessingsIsActive = false
          this.Map.featureGroups[FEATURE_GROUPS.FEATURES].setStyle({
            fillColor: LAYER_COLORS.DEFAULT,
            color: LAYER_COLORS.DEFAULT
          })
        }
      },
      onCreated() {
        const abCameraType = this.Processing["ab_camera_type"]
        const abProcessingType = this.Processing["ab_processing_type"]
        const listPostProcessingPricesPromise = listPostProcessingPrices(this.$apiAuth.getAuthToken(), abCameraType, abProcessingType)
          .then(res => {
            const data = res.data.data

            const cropTypes = []
            const agronomicAnalyzes = []

            forEach(data, (item) => {
              if (!some(cropTypes, item["crop_type"]))
                cropTypes.push(item["crop_type"])
              if (!some(agronomicAnalyzes, item["agronomic_analyzes"]))
                agronomicAnalyzes.push(item["agronomic_analyzes"])
            })

            this.postProcessingPrices = {
              cropTypes: cropTypes,
              agronomicAnalyzes: agronomicAnalyzes,
              all: data,
            }
          })

        const getSubscriptionPromise = this.$subsMng.getSubscription(this.$apiAuth.getAuthToken())

        Promise.all([listPostProcessingPricesPromise, getSubscriptionPromise])
          .finally(() => {
            this.isLoading = false            
          })
      },
      isAllowedToAdd() {
        if (!this.postProcessingPrices) {
          this.$notify(new NotificationOptions({
            message: "Erro indefinido, por favor tente novamente mais tarde",
            type: NOTIFICATION_TYPES.WARNING
          }))
          return false
        }
        return true
      },
      onCancelClick() {
        this.clearPostProcessingData()
        this.$refs["panel"].toggle()
      },
      onConfirmClick() {
        this.isLoadingConfirm = true
        if (this.$subsMng.isSubscriptionEmpty ||
          !this.$subsMng.subscription["bl_activated"]
        ) {
          this.expiredSubscriptionHandler()
          this.isLoadingConfirm = false
          return
        }
        if (!this.$subsMng.subscriptionPlanConfig["bl_allow_post_processing"]) {
          this.invalidSubscriptionHandler()
          this.isLoadingConfirm = false
          return
        }
        if (this.chargeTypeIsCredits) {
          if (!this.verifyMinPrice())
            this.minPriceConfirmRequest()
          else
            this.normalConfirmRequest()
          this.isLoadingConfirm = false
        } else {
          if (!this.verifyMinHectare()) {
            this.minHectareConfirmRequest()
            this.isLoadingConfirm = false
          } else {
            this.insufficient_funds = false
            this.itemsProcessed = 0
            forEach(this.selectedAnalysisTypes , item => {
              let dataProcessing = {
                "str_crop_type": this.abCropType ,
                "str_analysis_type": item.ab_analysis_type
              }
              getAfterProcessingItens(this.$apiAuth.getAuthToken(), dataProcessing)
              .then((res) => {              
                const data = res.data.data
                const userData = store.getters[GET_USER_DATA]
                let dataSend = {
                  "cd_user": userData.idUserAccount,
                  "id_type_hectare_package": data.cd_hectare_package
                }
                getUserTotalHectarePackage(this.$apiAuth.getAuthToken(), dataSend)
                .then((res) => {    
                  const data =  res.data.data
                  this.itemsProcessed++
                  if(lt(data.total_hectar, this.flTotalArea)) { 
                    this.insufficient_funds = true
                    var packageHectare = "Indefinido"
                    var saldo = 0
                    try{
                      packageHectare = data.data[0].hectare_package.nm_hectare_package
                      saldo = data.total_hectar
                    }catch (e){
                      console.error(e)
                    }
                    const dialogContent = packageHectare == 'Indefinido' ?
                        'Saldo insuficiente' :
                        `Saldo insuficiente para o package hectare: ${packageHectare}. <br> Saldo atual: ${saldo} ha`
                    this.$dialog(new DialogOptions({
                      title: "Aviso",
                      content: dialogContent,
                      type: DIALOG_TYPES.ALERT
                    }))
                    this.isLoadingConfirm = false                       
                  } else {
                    if(this.flTotalPrice < this.minPrice) {
                      this.isLoadingConfirm = false
                      this.aknowledgeMinimunDialog()
                    }else {
                      this.isLoadingConfirm = false
                      this.normalConfirmRequest()
                    }
                  }               
                })                                   
              })
              .catch(() => {
                this.$notify(new NotificationOptions({
                  message: "Ocorreu algum erro ao solicitar total de package hectare, tente novamente mais tarde.",
                  type: NOTIFICATION_TYPES.ERROR
                }))
                this.isLoadingConfirm = false   
              })    
            }) 
          }
        }

      },
      invalidSubscriptionHandler() {
        this.$dialog(new DialogOptions({
          width: "650px",
          type: DIALOG_TYPES.BUSINESS_ONLY,
          content: `Seu plano não permite solicitação de <br/><b>análises agronômicas</b>.<br/>
            Atualize seu plano e ganhe mais vantagens.`
        }))
      },
      expiredSubscriptionHandler() {
        this.$dialog(new DialogOptions({
          width: "650px",
          type: DIALOG_TYPES.SUBSCRIPTION_EXPIRED,
          content: `Para solicitar análises agronômicas, assine agora.`
        }))
      },
      normalConfirmRequest() {
        this.$dialog(new DialogOptions({
          title: "Análise agronômica",
          content: "Deseja confirmar a solicitação de análise agronômica?",
          type: DIALOG_TYPES.CONFIRM,
          onConfirm: this.postProcessingRequestHandler
        }))
      },
      aknowledgeMinimunDialog() {
        this.$dialog(new DialogOptions({
          title: "Preço minimo não atingido",
          content: "O pedido mínimo por análise é de 20 hectares, ao continuar você concorda com o valor.",
          type: DIALOG_TYPES.CONFIRM,
          onConfirm: this.postProcessingRequestHandler
        }))
      },
      verifyMinHectare() {
        let isValid = true
        if(lt(this.flTotalArea, this.minHectare)) {
          isValid = false
          return isValid
        }
        return isValid
      },
      verifyMinPrice() {
        let isValid = true
        forEach(this.selectedAnalysisTypes, analysisType => {
          let flPriceMultiplier = 0.0
          const item = find(this.postProcessingPrices.all, priceItem => {
            return isEqual(priceItem["agronomic_analyzes"]["ab_analysis_type"], analysisType["ab_analysis_type"]) &&
              isEqual(priceItem["crop_type"]["ab_crop_type"], this.abCropType)
          })
          if (item)
            flPriceMultiplier += this.$appMng.isIntl ? item["price_product"]["fl_intl_base_price"] : item["price_product"]["fl_base_price"]

          if (lt((flPriceMultiplier * this.flTotalArea), this.minPrice)) {
            isValid = false
            return isValid
          }
        })
        return isValid
      },
      minHectareConfirmRequest() {        
        this.$dialog(new DialogOptions({
          title: "Aviso",
          content: `A área mínima requirida é de ${this.minHectare.toFixed(2)} Hectares`,
          type: DIALOG_TYPES.ALERT
        }))        
      },
      minPriceConfirmRequest() {
        this.$dialog(new DialogOptions({
          title: "Análise agronômica",
          content: `O preço mínimo por tipo de análise agronômica é de ${this.currencySymbol} ${this.minPrice.toFixed(2).replace(".", ",")}<br>Continuar?`,
          type: DIALOG_TYPES.CONFIRM,
          onConfirm: this.postProcessingRequestHandler
        }))
      },
      postProcessingRequestHandler() {
        this.isRequesting = true

        const lstCdField = map(this.fields, item => item["field"]["id_field"])
        const postProcessingData = {
          cd_processing: this.Processing["id_processing"],
          lst_cd_field: lstCdField,
          lst_analysis_type: map(this.selectedAnalysisTypes, item => item["ab_analysis_type"]),
          ab_crop_type: this.abCropType
        }
        createFieldsPostProcessing(this.$apiAuth.getAuthToken(), postProcessingData)
          .then((res) => {
            const fieldsPostProcessing = res.data.data
            const cartData = {
              str_description: "Análise agronômica",
              is_intl: this.$appMng.isIntl,
              cd_field_post_processing: fieldsPostProcessing["id_field_post_processing"],
            }
            addUpdatePostProcessing(this.$apiAuth.getAuthToken(), cartData)
              .then((res) => {
                const shoppingCart = res.data.data
                const length = shoppingCart["processing_cart"].length + shoppingCart["post_processing_cart"].length + shoppingCart["subscription_cart"].length
                this.$appMng.setShoppingCartLength(length)
                this.$router.push("/app/payment")
              })
              .catch(() => {
                this.$notify(new NotificationOptions({
                  message: "Ocorreu algum erro ao solicitar sua análise, tente novamente mais tarde.",
                  type: NOTIFICATION_TYPES.ERROR
                }))
              })
            this.clearPostProcessingData()
          })
          .catch(() => {
            this.$notify(new NotificationOptions({
              message: "Ocorreu algum erro ao solicitar sua análise, tente novamente mais tarde.",
              type: NOTIFICATION_TYPES.ERROR
            }))
          })
          .finally(() => {
            this.isRequesting = false
          })
      },
      onAbCropTypeChange() {
        this.clearPostProcessingData()
      },
      clearPostProcessingData() {
        this.selectedAnalysisTypes.splice(0, this.selectedAnalysisTypes.length)
        this.flPriceMultiplier = 0.0
      },
      ...mapActions({
        setIsPostProcessingRequestState: SET_IS_POST_PROCESSING_REQUEST_STATE
      })
    },
    filters: {
      toFixedWithComma(value) {
        return value.toFixed(2).replace(".", ",")
      }
    },
    computed: {
      chargeTypeIsCredits() {
        if (this.$subsMng.subscriptionPlan["str_charge_type_system"] == 'credits')
          return true
        return false
      },
      cropTypesFilterList() {
        return CROP_TYPES_FILTER_LIST
      },
      Map() {
        return this._Map()
      },
      Processing() {
        return this._Processing()
      },
      analysisTypesIsEmpty() {
        if (!this.postProcessingPrices) return true
        return isEmpty(this.postProcessingPrices.agronomicAnalyzes)
      },
      flTotalArea() {
        let flArea = 0.0
        forEach(this.fields, item => {
          flArea += item["field"]["fl_area"]
        })
        return flArea
      },
      flTotalPrice() {
        return this.flPriceMultiplier * this.flTotalArea
      },
      flTotalPriceIsEmpty() {
        if (this.$subsMng.subscriptionPlan["ab_subscription_plan"] === "PRO_PLAN_TRIAL_TOTVS" || this.$subsMng.subscriptionPlan["ab_subscription_plan"] === "ENTERPISE_PLAN_TRIAL_TOTVS") {
          return isEmpty(this.selectedAnalysisTypes) || !this.abCropType || isEmpty(this.fields)
        }
        return this.flTotalPrice === 0
      },
      currencySymbol() {
        if (this.$appMng.isIntl)
          return "$"
        return "R$"
      },
      minHectare() {
        let minHectare = 0
        if (this.$subsMng.subscriptionPlan["ab_subscription_plan"] === "ENTERPISE_PLAN_TRIAL_TOTVS")
          minHectare = 0.0
        return minHectare
      },      
      minPrice() {
        let minPrice = 0.0
        if (this.$appMng.isIntl)
          minPrice = 20.00
        else
          minPrice = 60.00
        if (this.$subsMng.subscriptionPlan["ab_subscription_plan"] === "ENTERPISE_PLAN_TRIAL_TOTVS")
          minPrice = 0.0
        return minPrice
      },
    },
    created() {
      PostProcessingsRequestEventBus.$on("add", this.onAdd)
      PostProcessingsRequestEventBus.$on("remove", this.onRemove)
      this.onCreated()
    }
  }
</script>

<style scoped lang="scss">
  ::v-deep .field-list-empty {
    .description {
      font-size: 14px !important;
    }
  }

  .post-processing-active--text {
    color: #93be20 !important;
  }

</style>
